var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FrequencySplitBoxAdapter_crossoverParametric;
import { StringMapping, ValueMapping } from "@opendaw/lib-std";
import { DeviceManualUrls } from "../../DeviceManualUrls";
import { AudioCompositeAdapter } from "./AudioEffectComposite/AudioCompositeAdapter";
import { ParameterAdapterSet } from "../../ParameterAdapterSet";
const CrossoverMapping = ValueMapping.exponential(20.0, 20000);
const CrossoverString = StringMapping.numeric({ unit: "Hz", fractionDigits: 0 });
export class FrequencySplitBoxAdapter extends AudioCompositeAdapter {
    constructor(context, box) {
        super(context, box);
        _FrequencySplitBoxAdapter_crossoverParametric.set(this, void 0);
        __classPrivateFieldSet(this, _FrequencySplitBoxAdapter_crossoverParametric, new ParameterAdapterSet(context), "f");
        this.crossover = [
            __classPrivateFieldGet(this, _FrequencySplitBoxAdapter_crossoverParametric, "f").createParameter(box.crossover1, CrossoverMapping, CrossoverString, "Crossover 1"),
            __classPrivateFieldGet(this, _FrequencySplitBoxAdapter_crossoverParametric, "f").createParameter(box.crossover2, CrossoverMapping, CrossoverString, "Crossover 2"),
            __classPrivateFieldGet(this, _FrequencySplitBoxAdapter_crossoverParametric, "f").createParameter(box.crossover3, CrossoverMapping, CrossoverString, "Crossover 3")
        ];
    }
    get crossoverCount() { return Math.max(0, this.entries.adapters().length - 1); }
    get spectrum() { return this.address.append(0xFFF); }
    get entriesFixed() { return true; }
    get manualUrl() { return DeviceManualUrls.FrequencySplit; }
}
_FrequencySplitBoxAdapter_crossoverParametric = new WeakMap();
FrequencySplitBoxAdapter.MAX_BANDS = 4;
